import Table from 'react-bootstrap/Table';
import {useTranslation} from "react-i18next";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import PlayerNameWithFlag from "../PlayerNameWithFlag";
import type {Player} from "../../../types/domain";

interface PlayerTableProps {
  players: Player[];
  showRank?: boolean;
  hideMedals?: boolean;
}

function PlayerTable(props: PlayerTableProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleOnClick = useCallback((id: number) => navigate('/players/' + id), [navigate]);
  const showMedals = !props.hideMedals;

    return (
        <Table striped bordered hover size="sm" variant="dark">
            <thead style={{"textTransform": "none"}}>
            <tr>
              {props.showRank ? <th style={{width: "2rem",textAlign: "center", verticalAlign: "middle"}}>#</th> : null}
              <th style={{width: "2rem", textAlign: "center", verticalAlign: "middle"}}>{t("elo")}</th>
              <th style={{verticalAlign: "middle"}} className="hide-on-mobile">{t("player")}</th>
              <th style={{width: "8rem", verticalAlign: "middle", textAlign: "center"}}>{t("tournaments")}</th>
              {showMedals && <th style={{width: "3rem", textAlign: "center"}} className="hide-on-mobile"><div className="achievement-image-div">
                <img src="/icons/gold-medal.png" className="table-header-image" alt="1st" />
              </div></th>}
              {showMedals && <th style={{width: "3rem", textAlign: "center"}} className="hide-on-mobile"><div className="achievement-image-div">
                <img src="/icons/silver-medal.png" className="table-header-image" alt="2nd" />
              </div></th>}
              {showMedals && <th style={{width: "3rem", textAlign: "center"}} className="hide-on-mobile"><div className="achievement-image-div">
                <img src="/icons/bronze-medal.png" className="table-header-image" alt="3rd" />
              </div></th>}
            </tr>
            </thead>
            <tbody>
            {props.players.map(player => {
                return (
                    <tr key={player.id} onClick={() => handleOnClick(player.id)} className="clickable">
                      {props.showRank ? <th style={{textAlign: "center", verticalAlign: "middle", width: "2rem"}}>{player.rank}.</th> : null}
                      <th style={{textAlign: "center", verticalAlign: "middle", width: "2rem"}}>{player.elo}</th>
                      <th><PlayerNameWithFlag player={player} aliasOnly={true} /></th>
                      <th style={{textAlign: "center", verticalAlign: "middle"}} className="hide-on-mobile">{player.tournamentsPlayed}</th>
                      {showMedals && <th style={{textAlign: "center", verticalAlign: "middle", color: "#FFD700"}} className="hide-on-mobile">{player.firstPlace}</th>}
                      {showMedals && <th style={{textAlign: "center", verticalAlign: "middle", color: "#C0C0C0"}} className="hide-on-mobile">{player.secondPlace}</th>}
                      {showMedals && <th style={{textAlign: "center", verticalAlign: "middle", color: "#CD7F32"}} className="hide-on-mobile">{player.thirdPlace}</th>}
                    </tr>
                )
            })}
            </tbody>
        </Table>
    );
}

export default PlayerTable
